import { render, staticRenderFns } from "./CreateMaterial.vue?vue&type=template&id=6577dfe8&scoped=true&"
import script from "./CreateMaterial.vue?vue&type=script&lang=js&"
export * from "./CreateMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6577dfe8",
  null
  
)

export default component.exports